import Vue from 'vue'
import VueRouter, { Route } from 'vue-router'
import store from '@/store'
import routes from '@/router/routes';

Vue.use(VueRouter)

/* component: () => import(webpackChunkName: "about" '../views/About.vue') */

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
});

router.beforeEach(async (to, from, next) => {
	
	// TODO: refactor the conditional, not properly checking user, always fails on page reload
	if (store.getters['auth/token'] && !store.getters['auth/check']) { 
		try {
			await store.dispatch('auth/fetchUser')
		} catch (e) {}
	}

	let route = reroute(to)
	
	if (route) {
		next(route);
	} else {
		next();
	}
})

interface Rule {
	[key: string]: {
		fail: string,
		check(): boolean
	};
}

const rules: Rule = {
	guest: {
		fail: 'index',
		check: (): boolean => (!store.getters['auth/check'])
	},
	auth: {
		fail: 'login',
		check: (): boolean => (store.getters['auth/check'])
	},
	admins: {
		fail: 'profile',
		check: (): boolean => (store.getters['auth/admins'])
	},
	superAdmin: {
		fail: 'profile',
		check: (): boolean => (store.getters['auth/superAdmin'])
	},
	admin: {
		fail: 'profile',
		check: (): boolean => (store.getters['auth/admin'])
	},
	parent: {
		fail: 'profile',
		check: (): boolean => (store.getters['auth/parent'])
	},
	babysitter: {
		fail: 'profile',
		check: (): boolean => (store.getters['auth/babysitter'])
	}
}

function reroute(to: Route): any {

	let failRoute: any = false;
	let checkResult: boolean = false;

	to.meta.rules && to.meta.rules.forEach((rule: string) => {

		let check = false

		if (Array.isArray(rule)) {
			
			let checks: any = []

			for (let i in rule) {
				checks[i] = rules[rule[i]].check();
				check = check || checks[i];
			}

			if (!check && !failRoute) {
				failRoute = rules[rule[checks.indexOf(false)]].fail;
			}

		} else {

			check = rules[rule].check();

			if (!check && !failRoute) {
				failRoute = rules[rule].fail;
			}
		}

		checkResult = checkResult && check;
	})

	if (!checkResult && failRoute) {
		return { name: failRoute };
	}

	return false;
}

export default router
